module.exports = __webpack_public_path__ + "img/video.98ffdd3c.png";